import Home from './routes/Home.svelte'
import Fotos from './routes/Fotos.svelte'
import Cds from './routes/Cds.svelte'
import Videos from './routes/Videos.svelte'

const routes = {
    '/': Home,
    '/home': Home,
    '/fotos': Fotos,
    '/videos': Videos,
    '/cds': Cds
}

export default routes
